import React from 'react';
import { throttle } from 'throttle-debounce';

interface Options {
  enabled?: boolean,
  distance?: number,
  throttleDelay?: number
}

export function useOnScrollDown(cb: () => void, options: Options = {}) {
  const { enabled = true, distance = 50, throttleDelay = 100 } = options;
  const windowScrollYRef = React.useRef<number>(null);

  React.useLayoutEffect(() => {
    if (enabled) {
      windowScrollYRef.current = window.scrollY;
    }
  }, [enabled]);

  const onWindowScroll = React.useCallback(() => {
    if (Math.abs(window.scrollY - windowScrollYRef.current) > distance) {
      cb();
    }
  }, [cb, distance]);

  const throttledOnScroll = React.useCallback(throttle(throttleDelay, onWindowScroll), [onWindowScroll]);

  React.useEffect(() => {
    if (enabled) {
      window.addEventListener('scroll', throttledOnScroll);
    } else {
      window.removeEventListener('scroll', throttledOnScroll);
    }
    return () => {
      window.removeEventListener('scroll', throttledOnScroll);
    };
  }, [enabled, throttledOnScroll]);

  return null;
}
